import { render } from "./ProfileRow.vue?vue&type=template&id=4752b720&scoped=true&ts=true"
import script from "./ProfileRow.vue?vue&type=script&lang=ts"
export * from "./ProfileRow.vue?vue&type=script&lang=ts"

import "./ProfileRow.vue?vue&type=style&index=0&id=4752b720&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4752b720"]])

export default __exports__